/**
 * P3-002: Auth atoms — Jotai state for transient challenge/session UI state.
 *
 * Server operations use TanStack mutations.
 * Profile, permissions, entitlements, and memberships use TanStack Query.
 * Only transient UI state (challenge tokens, MFA setup data) lives in Jotai.
 */
import { atom, getDefaultStore } from 'jotai';
import type { AuthState } from './auth.types';

export const initialAuthState: AuthState = {
  user: null,
  isAuthenticated: false,
  loading: true,
  mfaRequired: false,
  mfaEnrolled: false,
  currentContext: null,
};

export const authAtom = atom<AuthState>(initialAuthState);
export const authStore = getDefaultStore();
